import { render, staticRenderFns } from "./FormValidateButton.vue?vue&type=template&id=50258258&scoped=true"
import script from "./FormValidateButton.vue?vue&type=script&lang=js"
export * from "./FormValidateButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50258258",
  null
  
)

export default component.exports